// Typed wrappers for the go-pim generated-documents surface — READ-ONLY.
//
// go-pim generates invoices/receipts at settle time; the panel lists + links
// to them. There is NO "list all documents for a company" endpoint yet — the
// backend only lists by payment_ref — so the Documents page is a LOOKUP by
// payment reference (with an optional company filter). A company-wide feed is a
// future backend addition.
//
// Money handling: amount_minor + tax_amount_minor are bigint (money is bigint
// end-to-end); RawDocument carries `number | bigint` and we normalise.
import { apiClient } from "./client";

export type DocumentType = "receipt" | "invoice";

interface RawDocument {
  id: string;
  type: DocumentType;
  number: string;
  template: string;
  amount_minor: number | bigint;
  currency: string;
  taxation: string;
  tax_amount_minor: number | bigint;
  issued_at: string;
  /** Public shareable link — `/r/{slug}` on go-pim's public origin. */
  url: string;
  slug?: string;
  company_id?: string;
  payment_ref?: string;
}

export interface GeneratedDocument {
  id: string;
  type: DocumentType;
  number: string;
  template: string;
  amount_minor: bigint;
  currency: string;
  taxation: string;
  tax_amount_minor: bigint;
  issued_at: string;
  url: string;
  slug?: string;
  company_id?: string;
  payment_ref?: string;
}

function normalizeDocument(r: RawDocument): GeneratedDocument {
  return {
    ...r,
    amount_minor: BigInt(r.amount_minor),
    tax_amount_minor: BigInt(r.tax_amount_minor),
  };
}

export interface ListDocumentsParams {
  /** Required — the backend only lists documents for a given payment. */
  payment_ref: string;
  /** Optional company filter. */
  company_id?: string;
}

/**
 * listDocuments — GET /v1/documents?payment_ref=&company_id=
 * ASSUMED SHAPE: `{ documents: RawDocument[] }`.
 */
export async function listDocuments(
  params: ListDocumentsParams,
): Promise<GeneratedDocument[]> {
  const resp = await apiClient.get<{ documents: RawDocument[] }>(
    "/v1/documents",
    { params },
  );
  return (resp.data.documents ?? []).map(normalizeDocument);
}

/** getDocumentBySlug — GET /v1/documents/by-slug/:slug */
export async function getDocumentBySlug(
  slug: string,
): Promise<GeneratedDocument> {
  const resp = await apiClient.get<RawDocument>(
    `/v1/documents/by-slug/${slug}`,
  );
  return normalizeDocument(resp.data);
}
